<template>
  <div class="wrapper-card-base">
    <!-- :style="`--accent-nav: ${accentColor};`" -->
    <div class="item-card sector-card d-flex flex-column">
      <div class="px-2 header-card border-bottom-basic">
        <div class="h-100 d-flex justify-content-between align-items-center">
          <div class="h-100 d-flex justify-content-start align-items-center">
            <component v-if="icon" :is="icon" class="mb-1" :title="title" />
            <div class="divisor-icon mx-2" />
            <h6 class="font-weigh-normal mb-0 card-title">{{ title }}</h6>
          </div>

          <div
            v-if="tags && tags.length && filteredTags.length"
            class="tag-icon-flex"
          >
            <span
              v-for="(tag, i) in filteredTags"
              @click="openModal(tag.title, tag.body)"
              class="tag-icon"
            >
              <element
                :key="i"
                :is="tag.icon"
                :title="tag.title"
                :body="tag.body"
                class="tag-item"
                :class="tag.class"
              />
            </span>
          </div>

          <div v-if="subtitle" class="d-flex align-items-center">
            <div class="d-flex align-items-end">
              <element
                v-if="subtitle.icon"
                :is="subtitle.icon"
                :title="subtitle.title"
                class="mr-3"
              />
              <span>{{ subtitle.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="px-2 body-card flex-grow-1 py-2 border-bottom-basic">
        <div
          v-for="(column, i) in columnsShowing"
          :key="i"
          class="row-details-card d-flex align-items-center"
          :class="{ 'pt-1': i }"
        >
          <div class="left d-flex align-items-center">
            <!-- <element
              v-if="column.icon"
              :is="column.icon"
              :title="column.title"
              class="mr-3"
            /> -->
            <span class="font-weight-bold">{{ column.title }}</span>
          </div>
          <div>
            <span v-if="column.format == 'schedule'">
              {{ getColumnValue(item, column) }}
            </span>
            <span v-else>
              {{ formatVal(getColumnValue(item, column), column) || "..." }}
            </span>
            <span v-if="column.measurement"></span>
          </div>
        </div>
      </div>
      <div class="px-2 footer">
        <b-checkbox
          v-if="!hideActions"
          v-show="isAdmin"
          class="checkbox"
          v-model="isSelected"
        />

        <div v-else />

        <div>
          <button
            v-if="footerButton && footerButton.title"
            @click="handleClickAction"
            class="footer-button btn btn-outline-secondary px-2 py-1 mr-3"
          >
            {{ footerButton.title }}
          </button>

          <button
            v-if="!hideActions"
            @click="editSingleItem"
            class="footer-button btn btn-outline-secondary px-2 py-1"
          >
            Editar
          </button>
        </div>
        <slot name="options-footer" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import SectorTagsModal from "@/pages/registerPages/Sectors/components/SectorTagsModal.vue";

export default {
  components: {
    SectorTagsModal,
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    footerButton: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    icon: {
      type: String,
      default: "earth-icon",
    },
    actionComponent: {
      type: String,
      default: "",
    },
    subtitle: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      default: "...",
    },
    accentColor: {
      type: String,
      default: "...",
    },
    value: {
      default: false,
      type: Boolean,
    },
    hideActions: {
      default: false,
      type: Boolean,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: [],
    },
    sortColumnsByKey: {
      type: String,
      default: "measurement",
    },
    orderByDesc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    filteredTags() {
      return this.tags.filter((tag) =>
        tag.tagValidator ? tag.tagValidator(this.item) : true
      );
    },
    isSelected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    columnsShowing() {
      return this.columnsSorted.map((col) => {
        col.title = this.formatColumnTitle(col.title);
        return col;
      });
    },
    columnsSorted() {
      const sortColumnsByKey = this.sortColumnsByKey;
      const orderByDesc = this.orderByDesc;
      const columns = [...this.columns];
      if (orderByDesc) {
        return columns.sort((a, b) => {
          const valA = a[sortColumnsByKey] || "";
          const valB = b[sortColumnsByKey] || "";
          if (orderByDesc) {
            return valB.localeCompare(valA);
          }
          return valA.localeCompare(valB);
        });
      }
      return columns;
    },
  },
  methods: {
    openModal(title, body) {
      this.$emit("TagsModal", title, body, this.item);
    },
    editSingleItem() {
      this.$emit("edit-single-item", this.item);
    },
    formatColumnTitle(title) {
      return title
        .split(" ")
        .map((word, i) => {
          if (!i) {
            return `${word.charAt(0)}${word.slice(1, word.length)}`;
          }
          return word.toLowerCase();
          forma;
        })
        .join(" ");
    },
    handleClickAction() {
      this.$emit("click-footer-action", this.item);
    },
    getColumnValue(item, column) {
      const baseVal = item[column.key];
      const transformedVal = column.transformData
        ? column.transformData(baseVal)
        : baseVal;
      return transformedVal;
    },
    formatFullDateTime(date) {
      if (!date) {
        return "";
      }
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    formatSchedule(date) {
      if (!date) {
        return "";
      }
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    formatFloat(val) {
      return val ? Number(val).toFixed(2) : 0.0;
    },
    formatJoinConcatString(val) {
      if (!val || !val.length) {
        return "";
      }
      const removedLast = val.slice(0, val.length - 1);
      const last = val[val.length - 1];
      return [removedLast.join(", "), last].filter((val) => val).join(" e ");
    },
    formatText(val) {
      if (!val) {
        return "";
      }
      return val.length > 25 ? `${val.slice(0, 25)}...` : val;
    },
    formatVal(val, column) {
      const measurement = column.measurement || "";
      const typeFormat = column.format;
      let formattedVal = val;
      if (typeFormat === "date") {
        formattedVal = this.formatFullDateTime(val);
      } else if (typeFormat === "float") {
        formattedVal = this.formatFloat(val);
      } else if (typeFormat === "text") {
        formattedVal = this.formatText(val);
      } else if (typeFormat === "join-concat-text") {
        formattedVal = this.formatJoinConcatString(val);
      }
      return `${formattedVal || "..."} ${formattedVal ? measurement : ""}`;
    },
  },
  components: { SectorTagsModal },
};
</script>

<style scoped>
.card-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer-button {
  font-size: 0.7em;
  /* padding: 3px 6px;
  border-radius: 5px;
  min-height: 1.5em;
  border: 1px solid #bebebe;
  font-weight: 500;
  color: #a1a1a1;
  transition: all .4s ease;
  background: none; */
}

.wrapper-card-base {
  overflow: hidden;
}

.sector-card {
  height: 220px;
}

.header {
  flex-basis: 34px;
}

.header-card {
  height: auto;
  padding-top: auto;
  min-height: 35px;
  letter-spacing: 0.1rem;
  background-color: var(--accent-nav);
  filter: brightness(1.1);
}

.header-card,
.header-card *:not(.tag-item) {
  color: white !important;
}

.header-card h5 {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  color: var(--text-gray-primary);
}

.material-design-icon:not(.tag-item) {
  margin-bottom: 3px;
}
.material-design-icon {
  font-size: 1.2rem;
}
.tag-icon-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.tag-icon {
  cursor: pointer;
  padding: 0.3em;
}
.sector-card .edited-icon,
.row-details-card .material-design-icon,
.sector-icon {
  color: var(--text-gray-tertiary);
  vertical-align: -2px;
}

.management-icon {
  color: #81b399;
  vertical-align: -0px;
  margin-right: 8px;
}

#details {
  padding-top: 100px;
  padding-bottom: 0 !important;
}

#details .content {
  padding-bottom: 0 !important;
}

.info {
  color: var(--text-gray-primary);
  margin-right: 5px;
}

.show-details-cards {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.row-details-card {
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 0.8em;
  color: var(--text-gray-primary);
}

.row-details-card .obs {
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-details-card span {
  font-weight: 500;
  color: var(--text-gray-primary);
}

.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}

.show-details-cards a:hover {
  background: #f5f5f5;
}

.footer {
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-top: 1px solid #ececec; */
}

.editor-name {
  font-size: 0.8em;
}

.header-mobile {
  min-height: 29px;
}

#details .content {
  margin-bottom: 60px;
}
@media screen and (max-width: 2000px) {
  .card-title {
    width: 21ch;
  }
}
@media screen and (max-width: 1490px) {
  .card-title {
    width: 12ch;
  }
}
@media screen and (max-width: 995px) {
  .card-title {
    width: 15ch;
  }
}
@media screen and (max-width: 767px) {
  #details .content {
    margin-bottom: 0;
    padding-bottom: 90px !important;
  }
  .card-title {
    width: 20ch;
  }
}
@media screen and (max-width: 576px) {
  .card-title {
    width: 100%;
  }
}
@media screen and (max-width: 380px) {
  .card-title {
    width: 20ch;
  }
}
.header {
  min-height: 90px;
}

#form {
  padding: 8px 0px 3em 0px;
}

#form,
#details {
  padding-top: 2.5em;
}

.border-bottom-basic {
  border-bottom: 1px solid var(--card-base-black);
}
.divisor-icon {
  width: 2px;
  background-color: white;
  height: 100%;
  opacity: 0.4;
}

.tag-item > :first-child {
  border-radius: 5px;
  color: #e07f52;
  background-color: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.tag-item > :first-child:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  /* transition: 0.7s;
  color: white;
  background-color: #e07f52 !important; */
}
</style>
